import { PickStatus } from './pick-status.js';
/** COMMITTED is excluded -- that stock is reserved against this warehouse, not yet moved out. */
export const TERMINAL_PICK_STATUS_IDS = [
    PickStatus.COMPLETED,
    PickStatus.CANCELLED,
];
//# sourceMappingURL=pick-terminal-statuses.js.map